import LanguageDetector from "i18next-browser-languagedetector";

const languageDetector = new LanguageDetector();

export { languageDetector };
